<template>
  <div class="content">
    <div class="left">
      <div
        v-for="(item, index) in navBarList"
        :key="index"
        class="leftItem"
        :class="{ selected: selectedIndex === index }"
        @click="openPage(item, index)"
      >
        <!-- <img :src="item.logo" alt="" style="margin-right: 10px" /> -->
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="right">
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane :label="$t('myAffairs.uncompleted')" name="noDoes">
          </el-tab-pane>
          <el-tab-pane :label="$t('myAffairs.completed')" name="does">
          </el-tab-pane>
          <el-tab-pane :label="$t('myAffairs.unread')" name="noRead">
          </el-tab-pane>
          <el-tab-pane :label="$t('myAffairs.read')" name="readed">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="serach">
        <div
          style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 25px"
        >
          <div style="display: flex">
            <div style="width: 100px; display: flex; align-items: center">
              {{ $t("myAffairs.keyWord") }}：
            </div>
            <el-input
              v-model="searchInput"
              :placeholder="$t('myAffairs.searchHolder')"
              style=""
              @input="serachValue"
            ></el-input>
          </div>
          <!-- <div style="display: flex">
            <div style="width: 85px; display: flex; align-items: center">
              {{ $t("myAffairs.source") }}：
            </div>
            <el-select v-model="selectValue" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
          <div style="display: flex; margin-right: 35px">
            <div style="width: 100px; display: flex; align-items: center">
              {{ $t("myAffairs.dateRange") }}：
            </div>
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 250px"
              value-format="yyyy-MM-dd"
              @change="changeDateRange"
              @clear="handleClear"
            >
            </el-date-picker>
          </div>
          <div>
            <el-dropdown trigger="click">
              <!-- ✅ 触发按钮：纯净按钮+下拉箭头，无任何多余内容 -->
              <el-button>
                订阅
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>

              <!-- ✅ 【核心修复】Vue2正确插槽名 + 必加容器 el-dropdown-menu -->
              <el-dropdown-menu slot="dropdown">
                <!-- 多选选项列表 -->
                <div
                  class="dropdown-option"
                  v-for="item in subscribeList"
                  :key="item?.id"
                  @click.stop="toggleSelect(item)"
                >
                  <!-- 选中项显示打勾图标 -->

                  {{ item.name }}
                  <i
                    class="el-icon-check"
                    v-if="isSelected(item)"
                    style="margin-left: 5px"
                  ></i>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="messageList"
          border
          style="width: 100%"
          @row-click="toMessageDetail"
        >
          <el-table-column
            prop="title"
            :label="$t('myAffairs.title')"
            align="left"
            header-align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="content"
            :label="$t('myAffairs.content')"
            width="360"
          >
          </el-table-column> -->
          <el-table-column
            prop="channelName"
            :label="$t('myAffairs.serviceSource')"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('myAffairs.date')"
            width="180"
            align="center"
          ></el-table-column>

          <!-- <el-table-column prop="fwly" :label="$t('myAffairs.serviceSource')">
          </el-table-column>
          <el-table-column prop="type" :label="$t('affairs.matterType')">
          </el-table-column>
          <el-table-column
            prop="time"
            :label="$t('myAffairs.lastReceivedTime')"
          >
          </el-table-column>
          <el-table-column
            prop="person"
            :label="$t('myAffairs.personEntrusted')"
          >
          </el-table-column>

          <el-table-column prop="address" :label="$t('myAffairs.options')">
            <template slot-scope="scope">
              <el-button
                @click="rowClick(scope.row)"
                type="text"
                size="small"
                >{{ $t("myAffairs.details") }}</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <div style="margin-top: 25px; display: flex; justify-content: center">
          <el-pagination
            background
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPages"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import messageDetail from "@/views/myAffairs/childCon/messageDetail.vue";
import request from "@/api/request";
import noticeDetail from "@/views/myAffairs/childCon/noticeDetail.vue";
export default {
  data() {
    return {
      selectedIndex: 0,
      currentPage4: 1,
      selectValue: "",
      options: [{ value: "1", label: "测试" }],
      activeName: "noDoes",
      searchInput: "",
      navBarList: [],
      value1: "",
      subscribeList: [],
      pageSizes: 10,
      totalPages: 0,
      messageList: [],
      currentId: "",
      optionList: [],
      selectedList: [], // 核心：维护已选中项的数组，后续取值用
    };
  },
  props: {
    info: {
      type: Object,
    },
  },
  watch: {
    // 监听 data 中的 message 属性
    currentId: {
      handler(newVal, oldVal) {
        this.getMessageList();
      },
      immediate: true,
    },
  },
  created() {
    console.log(this.$route.query.type);
    if (this.$route.query.type) {
      this.activeName = this.$route.query.type;
    }
    this.getSourchList();
    this.getSubscribeList();
    this.getMessageList();
    this.getDingyueList();
  },
  methods: {
    // 判断当前选项是否被选中
    isSelected(item) {
      return this.selectedList.some((val) => val.id === item.id);
    },
    // 点击选项：切换选中/取消选中状态
    toggleSelect(item) {
      const isChecked = this.isSelected(item);
      if (isChecked) {
        // 已选中 → 取消选中
        this.selectedList = this.selectedList.filter(
          (val) => val.id !== item.id
        );
      } else {
        // 未选中 → 选中
        this.selectedList.push(item);
      }
      request({
        url: `/api/msg/subscribe/add?targets=${this.getSelectedValues()}`,
        method: "get",
      })
        .then((res) => {
          this.getSourchList();
        })
        .catch((error) => {});
      console.log(this.getSelectedValues());
    },
    // 【按需添加】后续需要拿选中值的时候调用这个方法即可
    getSelectedValues() {
      // 返回纯value数组，比如 [1,3,5]，提交接口常用
      return this.selectedList.map((item) => item.id).join(",");
    },
    getDingyueList() {
      request({
        url: `/api/msg/subscribe/list`,
        method: "get",
      })
        .then((res) => {
          console.log(res);
          this.optionList = [...res];
          this.options.forEach((item) => {
            if (item.subscribe) {
              this.selectedList.push(item);
            }
          });
        })
        .catch((error) => {});
    },
    handleClear() {
      this.getMessageList();
    },
    changeDateRange(value) {
      this.value1 = [value?.[0], value?.[1]];
      this.getMessageList();
    },
    toMessageDetail(item) {
      console.log("item", item);
      if (item.read == 0) {
        request({
          url: `/api/msg?id=${item.id}`,
          method: "get",
        })
          .then((res) => {
            if (item?.jumpUrl) {
              window.open(item?.jumpUrl, "_blank");
            } else {
              this.$store.dispatch("page/openPage", {
                component: noticeDetail,
                title: "消息详情",
                props: {
                  info: item,
                  category: "all",
                },
              });
            }
            this.getMessageList();
          })
          .catch((error) => {});
      } else {
        if (item?.jumpUrl) {
          window.open(item?.jumpUrl, "_blank");
        } else {
          this.$store.dispatch("page/openPage", {
            component: noticeDetail,
            title: "消息详情",
            props: {
              info: item,
              category: "all",
            },
          });
        }
      }
      // window.open(row?.jumpUrl, "_blank");
    },
    openPage(item, index) {
      this.selectedIndex = index;
      this.currentId = item.id;
    },
    changeTab() {
      this.getMessageList();
    },
    handleSizeChange(val) {
      this.pageSizes = val;
      this.getMessageList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getMessageList();
      console.log(`当前页: ${val}`);
    },
    serachValue() {
      this.getMessageList();
    },
    getMessageList() {
      request({
        url: `/api/msg/list`,
        method: "post",
        data: {
          title: this.searchInput,
          pageNum: this.currentPage4,
          pageSize: this.pageSizes,
          read:
            this.activeName == "noRead"
              ? 0
              : this.activeName == "readed"
              ? 1
              : "",
          handle:
            this.activeName == "noDoes"
              ? 0
              : this.activeName == "does"
              ? 1
              : "",
          beginTime: this.value1?.[0],
          endTime: this.value1?.[1],
          channelId: this.currentId,
        },
      })
        .then((res) => {
          this.messageList = [...res?.rows];
          this.totalPages = res?.total;
        })
        .catch((error) => {});
    },
    getSourchList() {
      request({
        url: `/api/msg/channel/list`,
        method: "get",
      })
        .then((res) => {
          this.navBarList = [...res];
          this.navBarList.unshift({
            id: "",
            name: "全部",
          });
          this.currentId = this.navBarList[0]?.id;
        })
        .catch((error) => {});
    },
    getSubscribeList() {
      request({
        url: `/api/msg/subscribe/list`,
        method: "get",
      })
        .then((res) => {
          res.forEach((item) => {
            if (item.subscribe) {
              this.selectedList.push(item);
            }
          });
          this.subscribeList = [...res];
        })
        .catch((error) => {});
    },
    handleClick() {},
    rowClick() {
      // this.$router.push(`/myAffairs/messageDetail`);
      this.$store.dispatch("page/openPage", {
        component: messageDetail,
        title: this.$t("myAffairs.pendingDetail"),
        props: {
          category: "all",
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
/* 下拉选项容器样式 */
.dropdown-option-box {
  min-width: 160px;
  padding: 4px 0;
}
/* 选项基础样式 */
.dropdown-option {
  padding: 6px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
/* 鼠标悬浮背景色 */
.dropdown-option:hover {
  background-color: #f5f7fa;
}
/* ✅ 核心样式：未选中的项，隐藏打勾图标 */
.dropdown-option .el-icon-check {
  display: none;
  color: #409eff;
  margin-right: 8px;
  font-size: 14px;
}
/* ✅ 核心样式：选中的项 → 显示打勾图标 + 高亮背景色 */
.dropdown-option:hover .el-icon-check,
.dropdown-option:has(.el-icon-check:visible) {
  background-color: #e6f0ff;
}
/* 判断选中后，显示图标 */
.dropdown-option:has(.el-icon-check) .el-icon-check {
  display: inline-block;
}
.content {
  background: white;
  min-height: 100%;
  border-radius: 4px;
  padding: 30px;
  display: flex;
  // margin: 50px 10% 0 10%;
  .left {
    width: 17%;
    margin-right: 25px;
    .leftItem {
      background: #f5f7fb;
      margin-bottom: 15px;
      padding: 10px;
      border-radius: 4px;
    }
    .leftItem:hover {
      background: #6293ff;
      color: white;
    }
    .leftItem.selected {
      background: #6293ff;
      color: white;
    }
  }
  .right {
    width: 83%;
    ::v-deep .el-tabs__nav-wrap::after {
      background-color: transparent !important;
    }
    .serach {
      display: flex;
      // background: #f5f7fb;
      // padding: 15px 35px;
      margin-bottom: 25px;
      align-items: center;
    }
    .table {
      ::v-deep .el-table__header th {
        background-color: #f5f7fb;
        font-weight: bold;
        color: #333333;
        // height: 100%;
      }
    }
  }
}
</style>
